import request from '@/common/request';
/**
 * 登录
 */
export function Login(data) {
  return request({
    url: '/clinic/loginSave',
    method: 'POST',
    data
  });
}
